export default "__VITE_ASSET__B87WgiGS__"